import { tv } from "../../variants/tv.js";
const baseAutocompleteItemVariants = tv({
    slots: {
        itemWrapperSlot: 'flex h-16 cursor-pointer justify-between gap-2 rounded-lg border-2 border-transparent bg-neutral-1 p-2 transition-colors outline-none data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50 data-[highlighted]:bg-primary-2 data-[selected]:bg-primary-3',
        leftNodeAndTextSlot: 'flex gap-2',
        leftNodeIconWrapperSlot: 'my-auto flex h-12 w-12 shrink-0 items-center justify-center rounded-lg',
        textSlot: 'my-auto flex min-w-0 flex-col px-1',
        firstLineRowSlot: 'flex min-w-0 items-center gap-1',
        firstLineTextSlot: 'min-w-0 shrink',
        firstLineSuffixSlot: 'shrink-0',
        rightNodeSlot: 'my-auto'
    },
    variants: {
        isHighlightedWithKeyboard: {
            true: {
                itemWrapperSlot: 'border-2 border-primary-8'
            }
        },
        isIndented: {
            true: {
                leftNodeAndTextSlot: 'pl-6'
            }
        }
    },
    compoundVariants: [
        {
            class: {
                itemWrapperSlot: 'data-[highlighted]:data-[selected]:bg-primary-4'
            }
        }
    ],
    defaultVariants: {
        isHighlightedWithKeyboard: false,
        isIndented: false
    }
});
export { baseAutocompleteItemVariants };
